import { FC, HTMLAttributes } from 'react';
import { ProTooltip } from '../antd';
import classnames from 'classnames';
import './style.less';

export type sizeType = 'add' | 'delete' | 'edit' | 'search' | 'detail';
enum sizeName {
  add = '新增',
  delete = '删除',
  edit = '编辑',
  detail = '查看详情',
  search = '查询',
}
export interface OperationIconProps extends HTMLAttributes<HTMLDivElement> {
  /** 类型 */
  type: sizeType;
}
/** 操作按钮 已废弃 */
const OperationIcon: FC<OperationIconProps> = props => {
  const { type, ...resProps } = props;
  const classes = classnames('operation-icon-item', 'fa', {
    [`operation-icon-${type}`]: type,
    'fa-file-o': type === 'add',
    'fa-trash-o': type === 'delete',
    'fa-pencil-square-o': type === 'edit',
    'fa-eye': type === 'detail',
    'fa-search': type === 'search',
  });
  return (
    <div className="operation-icon" {...resProps}>
      {/* {
        sizeName[type] ?
      } */}
      <span className={classes}></span>
    </div>
  );
};

export default OperationIcon;
